import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";


const renderSwitch = () => {
  //@ts-ignore
  return <Switch>
    {routes.map((routeItem) => {
      return (
        //@ts-ignore
        <Route
          key={routeItem.component}
          path={routeItem.path}
          exact={routeItem.exact}
          //@ts-ignore
          component={lazy(() => import(`../pages/${routeItem.component}`))}
        />
      );
    })}
  </Switch>
}




const renderStyle = () => {
  //@ts-ignore
  return <Styles />
}


const Router = () => {


  return (
    <Suspense fallback={null}>
      {/** @ts=ignore */}
      {renderStyle()}
      <Header />
      {renderSwitch()}
      <Footer />
    </Suspense>
  );
};

export default Router;
